/* global THEME */
export const getTheme = () => THEME;
